<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    @if (patient().isPediatric()) {
      <p>
        WNL: Strong movement of all extremities. Normal speech. No tremors noted. Normal reflexes.
      </p>
    }
    @else {
      <p>
        WNL: Strong movement of all extremities. Normal speech. No tremors noted.
      </p>
    }

    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <div [formGroup]="formGroup()" class="form-container">
  <assessment-row title="Extremity Movement">
    <emr-input type="text" [control]="formGroup().controls.extremityMovement" [wnlControl]="'extremityMovement'"
      [wnlDefault]="''" />
  </assessment-row>

  <assessment-row title="Hand Grips">
    <emr-input type="select" [control]="formGroup().controls.handGrips" [options]="extremityStrengthOptions"
      [wnlControl]="'handGrips'" [wnlDefault]="'WNL'" />
  </assessment-row>

  <assessment-row title="LE Push/Pull">
    <emr-input type="select" [control]="formGroup().controls.lePushPull" [options]="extremityStrengthOptions"
      [wnlControl]="'lePushPull'" [wnlDefault]="'WNL'" />
  </assessment-row>

  <assessment-row title="Glascow Coma Scale Score">
    <emr-input type="text" [control]="formGroup().controls.gcss" [wnlControl]="'gcss'" [wnlDefault]="''" />
  </assessment-row>

  <h2>Sensation</h2>
  <div class="sensation">
    <emr-input type="select" label="RUE" [control]="formGroup().controls.sensationRue" [options]="sensationOptions"
      [wnlControl]="'rue'" [wnlDefault]="'Full sensation'" [bottomSpace]="true" />
    <emr-input type="select" label="LUE" [control]="formGroup().controls.sensationLue" [options]="sensationOptions"
      [wnlControl]="'lue'" [wnlDefault]="'Full sensation'" [bottomSpace]="true" />
    <emr-input type="select" label="RLE" [control]="formGroup().controls.sensationRle" [options]="sensationOptions"
      [wnlControl]="'rle'" [wnlDefault]="'Full sensation'" [bottomSpace]="true" />
    <emr-input type="select" label="LLE" [control]="formGroup().controls.sensationLle" [options]="sensationOptions"
      [wnlControl]="'lle'" [wnlDefault]="'Full sensation'" [bottomSpace]="true" />
  </div>

  <assessment-row title="Tremors">
    <emr-checkbox-group [control]="formGroup().controls.tremors" [options]="tremorsOptions" [wnlControl]="'tremors'"
      [wnlDefault]="[]" />
  </assessment-row>

  @if (patient().isObstetric()) {
  <assessment-row title="Epidural">
    <emr-checkbox [control]="formGroup().controls.isEpidural" label="Yes" [wnlControl]="'isEpidural'"
      [wnlDefault]="false"></emr-checkbox>
  </assessment-row>

    @if (formGroup().controls.isEpidural.value) {
    <assessment-row title="Level of Sensory Block">
      <emr-input type="text" [control]="formGroup().controls.sensoryBlockLevel"></emr-input>
    </assessment-row>
    }

  <assessment-row title="Abnormal Reflexes Noted">
    <emr-input type="text" [control]="formGroup().controls.abnormalReflexesNoted" [wnlControl]="'abnormalReflexesNoted'"
      [wnlDefault]="''"></emr-input>
  </assessment-row>
  }

  @if (patient().isPediatric()) {
    <assessment-row title="Abnormal Reflexes">
      <emr-checkbox [control]="formGroup().controls.abnormalReflexesPresent" label="Yes"
        [wnlControl]="'abnormalReflexesPresent'" [wnlDefault]="false"/>
    </assessment-row>
    @if (abnormalReflexes) {
      <assessment-row title="Abnormal Reflex Type">
        <emr-input type="select" [control]="formGroup().controls.abnormalReflexesType" [options]="abnormalReflexesOptions" />
      </assessment-row>
      <assessment-row title="Abnormal Reflex Details">
        <emr-input type="text" [control]="formGroup().controls.abnormalReflexesDetails"></emr-input>
      </assessment-row>
    }
  }

  <assessment-row title="Other Findings">
    <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
      [wnlDefault]="''" />
  </assessment-row>
</div>
</div>